import type { HTMLAttributes, ReactElement } from 'react';

import { cn } from '@/shared/lib/utils';

/** 콘텐츠 폭 기준선. 실제 값은 global.css 의 .u-container 한 곳에 있다. */
export function Container({ className, ...props }: HTMLAttributes<HTMLDivElement>): ReactElement {
  return <div className={cn('u-container', className)} {...props} />;
}
